"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyAddProjectV1ProjectsAddPostFiction = void 0;
exports.BodyAddProjectV1ProjectsAddPostFiction = {
    Fiction: "fiction",
    NonFiction: "non-fiction",
};
